module.exports = __webpack_public_path__ + "c4c8cfd47d832fe6e76a92d24a64e149.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/adobe_2023_chart.png
// module id = 1624
// module chunks = 0